document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-vibee-story-cta]');
  if (!btn) return;
  e.preventDefault();
  var atc = document.querySelector(
    '.vibee-pdp__atc-button, form[action*="/cart/add"] [type="submit"], [name="add"]',
  );
  if (!atc) return;
  atc.scrollIntoView({ behavior: 'smooth', block: 'center' });
  atc.classList.add('vibee-atc-pulse');
  setTimeout(function () {
    atc.classList.remove('vibee-atc-pulse');
  }, 1300);
});
